import { render, staticRenderFns } from "./VeiculosDestaque.vue?vue&type=template&id=0d1283dc&"
import script from "./VeiculosDestaque.js?vue&type=script&lang=js&"
export * from "./VeiculosDestaque.js?vue&type=script&lang=js&"
import style0 from "./VeiculosDestaque.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports